import React from "react";


const ESBotAvatar = () => {
    return(
        <div className="bg-accent w-10 h-10 grid place-items-center text-black rounded-full font-bold shrink-0">ESB</div>
    );
}

export default ESBotAvatar